import {countUp} from './agency-shortcode/js/script';
import {testimonials} from './clients-shortcode/js/script';
import {flexText} from './flex-text-shortcode/js/script';
import {projectsFlexText} from "./projects-shortcode/js/script";

export function shortcode_loader() {
    countUp();
    testimonials();
    flexText();
    projectsFlexText();
}
